/*
 * Reliable announcement-bar controls.
 * This capture-phase handler prevents Dawn's delayed slider handler from
 * swallowing rapid pointer/keyboard interactions on the announcement bar.
 */
(() => {
  const componentSelector = 'slideshow-component.announcement-bar';

  function slidesFor(component) {
    const slider = component.querySelector('[id^="Slider-"]');
    return slider ? Array.from(slider.querySelectorAll('[id^="Slide-"]')) : [];
  }

  function currentIndex(component, slides, slider) {
    const remembered = Number.parseInt(component.dataset.ammAnnouncementIndex, 10);
    if (Number.isInteger(remembered) && remembered >= 0 && remembered < slides.length) return remembered;

    const position = slider.scrollLeft;
    return slides.reduce(
      (nearest, slide, index) =>
        Math.abs(slide.offsetLeft - position) < Math.abs(slides[nearest].offsetLeft - position) ? index : nearest,
      0
    );
  }

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest(`${componentSelector} button[name="previous"], ${componentSelector} button[name="next"]`);
      if (!button) return;

      const component = button.closest(componentSelector);
      const slider = component.querySelector('[id^="Slider-"]');
      const slides = slidesFor(component);
      if (!slider || slides.length < 2) return;

      // Prevent the legacy delayed handler from competing with this direct target scroll.
      event.preventDefault();
      event.stopImmediatePropagation();

      const index = currentIndex(component, slides, slider);
      const direction = button.name === 'next' ? 1 : -1;
      const targetIndex = (index + direction + slides.length) % slides.length;

      component.dataset.ammAnnouncementIndex = String(targetIndex);
      component.announcementBarArrowButtonWasClicked = true;
      if (typeof component.pause === 'function') component.pause();
      slider.scrollTo({ left: slides[targetIndex].offsetLeft, behavior: 'smooth' });
    },
    true
  );
})();
